import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import './Patients.css';

function Clinics({ user, onUpdateUser }) {
    const [clinics, setClinics] = useState([]);
    const [plans, setPlans] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [selectedClinic, setSelectedClinic] = useState(null);
    const [clinicStaff, setClinicStaff] = useState([]);
    const [isEditing, setIsEditing] = useState(false);
    const [currentId, setCurrentId] = useState(null);
    const [viewMode, setViewMode] = useState('active'); // 'active' or 'trash'
    const [newClinic, setNewClinic] = useState({
        clinic_name: '',
        admin_username: '',
        admin_password: '',
        admin_fullname: '',
        domain: '',
        plan_id: 1,
        subscription_start: '',
        subscription_end: ''
    });

    useEffect(() => {
        fetchClinics();
        fetchPlans();
    }, [viewMode]);

    const fetchClinics = () => {
        axios.get(`./backend/get_clinics.php?trash=${viewMode === 'trash' ? 1 : 0}`)
            .then(res => {
                setClinics(Array.isArray(res.data) ? res.data : []);
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
            });
    };

    const fetchPlans = () => {
        axios.get('./backend/get_plans.php')
            .then(res => {
                setPlans(Array.isArray(res.data) ? res.data : []);
            })
            .catch(err => console.error(err));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (isEditing) {
            // Güncelleme
            axios.post('./backend/update_clinic.php', { 
                id: currentId, 
                name: newClinic.clinic_name, 
                domain: newClinic.domain,
                admin_username: newClinic.admin_username,
                admin_fullname: newClinic.admin_fullname,
                admin_password: newClinic.admin_password,
                plan_id: newClinic.plan_id,
                subscription_start: newClinic.subscription_start,
                subscription_end: newClinic.subscription_end
            })
                .then(res => {
                    toast.success(res.data.message);
                    setShowModal(false);
                    fetchClinics();
                })
                .catch(err => toast.error(err.response?.data?.message || 'Güncelleme başarısız.'));
        } else {
            // Yeni Ekleme
            axios.post('./backend/create_clinic.php', newClinic)
                .then(res => {
                    toast.success(res.data.message);
                    setShowModal(false);
                    fetchClinics();
                })
                .catch(err => toast.error(err.response?.data?.message || 'Klinik oluşturulamadı.'));
        }
    };

    const openAddModal = () => {
        setNewClinic({ 
            clinic_name: '', 
            admin_username: '', 
            admin_password: '', 
            admin_fullname: '', 
            domain: '', 
            plan_id: 1,
            subscription_start: new Date().toISOString().split('T')[0],
            subscription_end: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0]
        });
        setIsEditing(false);
        setShowModal(true);
    };

    const openEditModal = (clinic) => {
        setNewClinic({ 
            clinic_name: clinic.name, 
            domain: clinic.domain || '',
            admin_username: clinic.admin_username || '', admin_password: '', admin_fullname: clinic.admin_name || '',
            plan_id: clinic.plan_id || 1,
            subscription_start: clinic.subscription_start || '',
            subscription_end: clinic.subscription_end || ''
        });
        setCurrentId(clinic.id);
        setIsEditing(true);
        setShowModal(true);
    };

    const handleShowDetail = (clinic) => {
        setSelectedClinic(clinic);
        setClinicStaff([]); // Önce temizle
        setShowDetailModal(true);
        
        // Personel listesini çek
        axios.get(`./backend/get_clinic_users.php?id=${clinic.id}`)
            .then(res => {
                setClinicStaff(Array.isArray(res.data) ? res.data : []);
            })
            .catch(err => console.error(err));
    };

    const handleToggleStatus = (id, currentStatus) => {
        const newStatus = currentStatus == 1 ? 0 : 1;
        if(window.confirm(`Kliniği ${newStatus ? 'aktif' : 'pasif'} yapmak istediğinize emin misiniz?`)) {
            axios.post('./backend/toggle_clinic_status.php', { id, is_active: newStatus })
                .then(res => {
                    toast.success(res.data.message);
                    fetchClinics();
                })
                .catch(err => toast.error('İşlem başarısız.'));
        }
    };

    const handleImpersonate = (clinicId) => {
        if(window.confirm('Bu kliniğin yönetim paneline geçiş yapmak üzeresiniz. Devam edilsin mi?')) {
            axios.post('./backend/impersonate_clinic.php', { clinic_id: clinicId })
                .then(res => {
                    toast.success(res.data.message);
                    if (res.data.user && onUpdateUser) {
                        // Mevcut Süper Admin kullanıcısını sakla
                        localStorage.setItem('original_user', JSON.stringify(user));
                        onUpdateUser(res.data.user);
                        setTimeout(() => window.location.reload(), 1000);
                    }
                })
                .catch(err => toast.error(err.response?.data?.message || 'Geçiş başarısız.'));
        }
    };

    const handleBackup = (clinicId) => {
        if(window.confirm('Bu kliniğin veritabanı yedeğini almak istiyor musunuz?')) {
            axios.post('./backend/backup_clinic.php', { clinic_id: clinicId })
                .then(res => {
                    toast.success(res.data.message);
                    if (res.data.file_url) {
                        const link = document.createElement('a');
                        link.href = res.data.file_url;
                        link.setAttribute('download', res.data.filename);
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }
                    fetchClinics(); // Listeyi yenile (tarih güncellensin)
                })
                .catch(err => toast.error(err.response?.data?.message || 'Yedekleme başarısız.'));
        }
    };

    const handleSoftDelete = (id, name) => {
        if (window.confirm(`"${name}" kliniğini çöp kutusuna taşımak istediğinize emin misiniz?`)) {
            axios.post('./backend/soft_delete_clinic.php', { id })
                .then(res => {
                    toast.success(res.data.message);
                    fetchClinics();
                })
                .catch(err => toast.error(err.response?.data?.message || 'İşlem başarısız.'));
        }
    };

    const handlePermanentDelete = (id, name) => {
        if (window.confirm(`"${name}" kliniğini ve bağlı TÜM verileri (kullanıcılar, hastalar, randevular vb.) silmek istediğinize emin misiniz?`)) {
            if (window.confirm(`DİKKAT: Bu işlem GERİ ALINAMAZ! "${name}" kliniğini kalıcı olarak silmek istediğinizi onaylıyor musunuz?`)) {
                axios.post('./backend/delete_clinic_full.php', { id })
                    .then(res => {
                        toast.success(res.data.message);
                        fetchClinics();
                    })
                    .catch(err => toast.error(err.response?.data?.message || 'Silme işlemi başarısız.'));
            }
        }
    };

    const handleRestore = (id) => {
        if (window.confirm("Kliniği geri yüklemek istiyor musunuz?")) {
            axios.post('./backend/restore_clinic.php', { id })
                .then(res => {
                    toast.success(res.data.message);
                    fetchClinics();
                })
                .catch(err => toast.error('Geri yükleme başarısız.'));
        }
    };

    const formatBytes = (bytes, decimals = 2) => {
        if (!+bytes) return '0 Byte';
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
    };

    if (loading) return <div>Yükleniyor...</div>;

    const isExpiringSoon = (dateString) => {
        if (!dateString) return false;
        const today = new Date();
        const endDate = new Date(dateString);
        const diffTime = endDate - today;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        return diffDays <= 7;
    };

    return (
        <div className="patients-container">
            <div className="header-actions">
                <h2>Klinik Yönetimi (Süper Admin)</h2>
                <div style={{display: 'flex', gap: '10px'}}>
                    <button className="add-btn" onClick={() => setViewMode('active')} style={{background: viewMode === 'active' ? '#4e73df' : '#858796', boxShadow: 'none'}}>Aktif Klinikler</button>
                    <button className="add-btn" onClick={() => setViewMode('trash')} style={{background: viewMode === 'trash' ? '#e74a3b' : '#858796', boxShadow: 'none'}}>Çöp Kutusu</button>
                    {viewMode === 'active' && <button className="add-btn" onClick={openAddModal}>+ Yeni Klinik Oluştur</button>}
                </div>
            </div>

            <table className="data-table clinics-table">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Klinik Adı</th>
                        <th>Paket</th>
                        <th>Yönetici</th>
                        <th>Personel Sayısı</th>
                        <th>Bitiş Tarihi</th>
                        <th>Toplam Hasta</th>
                        <th>Disk</th>
                        <th>Durum</th>
                        <th>Son Yedekleme</th>
                        <th>Oluşturulma</th>
                        <th style={{textAlign: 'right'}}>İşlemler</th>
                    </tr>
                </thead>
                <tbody>
                    {clinics.map(c => {
                        const expiring = isExpiringSoon(c.subscription_end);
                        return (
                        <tr key={c.id} style={expiring ? { backgroundColor: '#fff5f5', borderLeft: '5px solid #e74a3b' } : {}}>
                            <td>{c.id}</td>
                            <td>{c.name}</td>
                            <td>
                                <span style={{
                                    background: c.plan_id == 1 ? '#e3f2fd' : (c.plan_id == 2 ? '#fff3cd' : '#ffebee'),
                                    color: c.plan_id == 1 ? '#4e73df' : (c.plan_id == 2 ? '#856404' : '#c62828'),
                                    padding: '3px 8px', borderRadius: '12px', fontSize: '0.8rem', fontWeight: '600'
                                }}>
                                    {c.plan_name || 'Starter'}
                                </span>
                            </td>
                            <td>{c.admin_name || '-'}</td>
                            <td>{c.user_count}</td>
                            <td>
                                {c.subscription_end ? (
                                    <span style={{color: expiring ? '#e74a3b' : 'inherit', fontWeight: expiring ? 'bold' : 'normal'}}>
                                        {new Date(c.subscription_end).toLocaleDateString()}
                                    </span>
                                ) : '-'}
                            </td>
                            <td>{c.patient_count}</td>
                            <td>{formatBytes(c.disk_usage)}</td>
                            <td>
                                <button 
                                    className={`status-badge ${c.is_active == 1 ? 'status-completed' : 'status-cancelled'}`}
                                    onClick={() => handleToggleStatus(c.id, c.is_active)}
                                    style={{ border: 'none', cursor: 'pointer', fontSize: '0.8rem' }}
                                >
                                    {c.is_active == 1 ? 'Aktif' : 'Pasif'}
                                </button>
                            </td>
                            <td>{c.last_backup_date ? new Date(c.last_backup_date).toLocaleDateString() : '-'}</td>
                            <td>{new Date(c.created_at).toLocaleDateString()}</td>
                            <td data-label="İşlemler">
                                <div className="action-buttons" style={{justifyContent: 'flex-end'}}>
                                    {viewMode === 'active' ? (
                                        <>
                                            <button className="edit-btn" style={{background: '#36b9cc', marginRight: '5px'}} onClick={() => handleBackup(c.id)} title="Yedek Al">
                                                Yedekle
                                            </button>
                                            {(c.clinic_phone || c.admin_phone) && (
                                                <a href={`https://wa.me/${(c.clinic_phone || c.admin_phone).replace(/[^0-9]/g, '')}?text=${encodeURIComponent("Merhaba, Dentis panelinizle ilgili...")}`} target="_blank" rel="noreferrer" className="edit-btn" style={{background: '#25D366', color: 'white', marginRight: '5px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', textDecoration: 'none', padding: '6px 10px'}} title="WhatsApp">
                                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.536 0 1.52 1.115 2.988 1.264 3.186.149.198 2.19 3.361 5.27 4.693 2.151.928 2.985.94 3.553.874.618-.071 1.758-.718 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.815 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/></svg>
                                                </a>
                                            )}
                                            <button className="edit-btn" style={{background: '#f6c23e', color: '#fff', marginRight: '5px'}} onClick={() => handleImpersonate(c.id)} title="Yönetici Olarak Giriş Yap">
                                                Giriş Yap
                                            </button>
                                            <button className="edit-btn" style={{background: '#4e73df', marginRight: '5px'}} onClick={() => handleShowDetail(c)}>Detay</button>
                                            <button className="edit-btn" onClick={() => openEditModal(c)}>Düzenle</button>
                                            <button className="delete-btn" style={{marginLeft: '5px'}} onClick={() => handleSoftDelete(c.id, c.name)} title="Çöp Kutusuna Taşı">
                                                Sil
                                            </button>
                                        </>
                                    ) : (
                                        <>
                                            <button className="edit-btn" style={{background: '#1cc88a', marginRight: '5px'}} onClick={() => handleRestore(c.id)} title="Geri Yükle">
                                                Geri Yükle
                                            </button>
                                            <button className="delete-btn" onClick={() => handlePermanentDelete(c.id, c.name)} title="Kalıcı Olarak Sil">
                                                Kalıcı Sil
                                            </button>
                                        </>
                                    )}
                                </div>
                            </td>
                        </tr>
                        );
                    })}
                </tbody>
            </table>

            {showModal && (
                <div className="modal-overlay">
                    <div className="modal">
                        <div className="modal-header">
                            <h3>{isEditing ? 'Kliniği Düzenle' : 'Yeni Klinik Oluştur'}</h3>
                            <button className="close-modal-btn" onClick={() => setShowModal(false)}>✕</button>
                        </div>
                        <div className="modal-body">
                            <form id="clinicForm" onSubmit={handleSubmit}>
                                <div className="form-group">
                                    <label>Klinik Adı</label>
                                    <input type="text" value={newClinic.clinic_name} onChange={e => setNewClinic({...newClinic, clinic_name: e.target.value})} required />
                                </div>
                                <div className="form-group">
                                    <label>Domain (Opsiyonel)</label>
                                    <input type="text" value={newClinic.domain} onChange={e => setNewClinic({...newClinic, domain: e.target.value})} placeholder="ornek.com" />
                                </div>
                                <div className="form-group">
                                    <label>Abonelik Paketi</label>
                                    <select value={newClinic.plan_id} onChange={e => setNewClinic({...newClinic, plan_id: e.target.value})} style={{ width: '100%', padding: '12px', borderRadius: '10px', border: '2px solid #eaecf4' }}>
                                        {plans.map(p => (
                                            <option key={p.id} value={p.id}>{p.name} ({parseFloat(p.price).toLocaleString('tr-TR')} ₺)</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="responsive-grid-2">
                                    <div className="form-group">
                                        <label>Başlangıç Tarihi</label>
                                        <input type="date" value={newClinic.subscription_start} onChange={e => setNewClinic({...newClinic, subscription_start: e.target.value})} />
                                    </div>
                                    <div className="form-group">
                                        <label>Bitiş Tarihi</label>
                                        <input type="date" value={newClinic.subscription_end} onChange={e => setNewClinic({...newClinic, subscription_end: e.target.value})} />
                                    </div>
                                </div>
                                
                                <h4 style={{color: '#4e73df', borderBottom: '1px solid #eee', paddingBottom: '5px'}}>Yönetici Bilgileri</h4>
                                <div className="form-group">
                                    <label>Yönetici Ad Soyad</label>
                                    <input type="text" value={newClinic.admin_fullname} onChange={e => setNewClinic({...newClinic, admin_fullname: e.target.value})} required />
                                </div>
                                <div className="form-group">
                                    <label>Kullanıcı Adı</label>
                                    <input type="text" value={newClinic.admin_username} onChange={e => setNewClinic({...newClinic, admin_username: e.target.value})} required />
                                </div>
                                <div className="form-group">
                                    <label>Şifre {isEditing && <small>(Değiştirmek istemiyorsanız boş bırakın)</small>}</label>
                                    <input type="password" value={newClinic.admin_password} onChange={e => setNewClinic({...newClinic, admin_password: e.target.value})} required={!isEditing} />
                                </div>
                            </form>
                        </div>
                        <div className="modal-actions">
                            <button type="button" className="cancel-btn" onClick={() => setShowModal(false)}>İptal</button>
                            <button type="submit" form="clinicForm" className="save-btn">{isEditing ? 'Güncelle' : 'Oluştur'}</button>
                        </div>
                    </div>
                </div>
            )}

            {/* Detay Modalı (Personel Listesi) */}
            {showDetailModal && selectedClinic && (
                <div className="modal-overlay" onClick={() => setShowDetailModal(false)}>
                    <div className="modal" onClick={e => e.stopPropagation()} style={{maxWidth: '700px'}}>
                        <div className="modal-header">
                            <h3>{selectedClinic.name} - Personel Listesi</h3>
                            <button className="close-modal-btn" onClick={() => setShowDetailModal(false)}>✕</button>
                        </div>
                        <div className="modal-body">
                            <div style={{marginBottom: '20px', display: 'flex', gap: '20px', background: '#f8f9fc', padding: '15px', borderRadius: '10px', flexWrap: 'wrap'}}>
                                <div><strong>Yönetici:</strong> {selectedClinic.admin_name}</div>
                                <div><strong>Kullanıcı Adı:</strong> {selectedClinic.admin_username}</div>
                                <div><strong>Toplam Personel:</strong> {selectedClinic.user_count}</div>
                                {(selectedClinic.clinic_phone || selectedClinic.admin_phone) && (
                                    <div style={{display: 'flex', alignItems: 'center'}}>
                                        <strong>İletişim:</strong>
                                        <a href={`https://wa.me/${(selectedClinic.clinic_phone || selectedClinic.admin_phone).replace(/[^0-9]/g, '')}?text=${encodeURIComponent("Merhaba, Dentis panelinizle ilgili...")}`} target="_blank" rel="noreferrer" style={{color: '#25D366', marginLeft: '5px', textDecoration: 'none', fontWeight: 'bold', display: 'flex', alignItems: 'center'}}>
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" style={{marginRight: '3px'}}><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.536 0 1.52 1.115 2.988 1.264 3.186.149.198 2.19 3.361 5.27 4.693 2.151.928 2.985.94 3.553.874.618-.071 1.758-.718 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.815 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/></svg>
                                            WhatsApp
                                        </a>
                                    </div>
                                )}
                            </div>

                            <table className="data-table" style={{boxShadow: 'none', border: '1px solid #eaecf4'}}>
                                <thead>
                                    <tr>
                                        <th>Ad Soyad</th>
                                        <th>Rol</th>
                                        <th>Kullanıcı Adı</th>
                                        <th>Son Giriş</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {clinicStaff.length > 0 ? clinicStaff.map(u => (
                                        <tr key={u.id}>
                                            <td>{u.full_name}</td>
                                            <td><span className={`status-badge ${u.role === 'admin' ? 'status-cancelled' : (u.role === 'doctor' ? 'status-completed' : 'status-scheduled')}`}>{u.role === 'admin' ? 'Yönetici' : (u.role === 'doctor' ? 'Doktor' : 'Personel')}</span></td>
                                            <td>{u.username}</td>
                                            <td>{u.last_login ? new Date(u.last_login).toLocaleString() : '-'}</td>
                                        </tr>
                                    )) : <tr><td colSpan="4" style={{textAlign: 'center'}}>Personel bulunamadı.</td></tr>}
                                </tbody>
                            </table>
                        </div>
                        <div className="modal-actions"><button className="save-btn" onClick={() => setShowDetailModal(false)}>Kapat</button></div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Clinics;